<template>
    <Button v-if="videoUrl" type="button" variant="outline" size="lg" @click="open = true">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" class="size-6 flex-none text-primary-600">
            <circle cx="12" cy="12" r="11.5" stroke="currentColor" stroke-opacity="0.3"></circle>
            <path d="M9.5 14.382V9.618a.5.5 0 0 1 .724-.447l4.764 2.382a.5.5 0 0 1 0 .894l-4.764 2.382a.5.5 0 0 1-.724-.447Z"
                fill="currentColor" stroke="currentColor"></path>
        </svg>
        <span>Watch the video</span>
    </Button>

    <Dialog v-model:visible="open" modal header="Watch the video" :style="{ width: '48rem' }" class="mx-4"
        @hide="pauseVideo">
        <video ref="videoEl" :src="videoUrl" controls autoplay class="w-full rounded-lg bg-black"></video>
    </Dialog>
</template>

<script setup>
import { ref } from 'vue';
import Button from '@/components/ui/Button.vue';
import Dialog from 'primevue/dialog';

defineProps({
    videoUrl: { type: String, default: '' },
});

const open = ref(false);
const videoEl = ref(null);

const pauseVideo = () => {
    videoEl.value?.pause();
};
</script>
